import styled from "styled-components";
import { motion } from "framer-motion";

export const ContainerNecesitoTurno = styled(motion.div)`
  width: 100%;
  height: 90vh;
  height: 90dvh;
  background: transparent;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const TextNecesitoTurno = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 14%;
  .title-saludo {
    font-weight: 400;
    font-size: 24px;
    line-height: 150%;
    text-align: center;
    width: 365px;
  }
  .title-pregunta {
    font-weight: 400;
    font-size: 22px;
    line-height: 150%;
    text-align: center;
    width: 365px;
  }
  .title-negrita {
    font-weight: bold;
  }
`;

export const BtnContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 26px;
  svg {
    width: 25px;
    height: 25px;
  }
  /* Tablet: 2 columnas */
  @media (min-width: 768px) and (max-width: 1199px) {
    display: flex;
    flex-direction: row;
    gap: 24px;
    max-width: 900px;
    padding: 20px;
  }
  /* Desktop: 3 columnas */
  @media (min-width: 1200px) {
    display: flex;
    flex-direction: row;
    gap: 28px;
    max-width: 1200px;
    padding: 40px;
  }
`;
